import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import UserEntity, { UserType } from "../../../../domain/entities/UserEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import UserDto from "../../../dto/UserDto";
import KeyWordLocalization from "../../../../presentation/utils/KeyWordLocalization";

const LoginWithUserAndPasswordApiImpl = async (user: string, password: string): Promise<Either<ErrorEntity, UserEntity>> => {
    try {
        const relativeRoute = "/login";
        const body = { 'username': user, 'password': password };

        const response = await di.get<HostApi>(HostApiName).post(relativeRoute, body);
        if (response.detail == "Invalid username or password") return left({ code: KeyWordLocalization.ErrorHostInvalidUsernameOrPassword });
        console.log("LoginWithUserAndPasswordApiImpl response", response);
        di.get<HostApi>(HostApiName).setToken(response.token);
        const userParsed = UserDto.fromJSON(response.user);
        console.log("user", userParsed);
        if(userParsed.role != UserType.ADMIN) return left({ code: KeyWordLocalization.ErrorUnauthorized})
        return right(userParsed);
    } catch (e) {
        return left(ErrorEntityFromError(e));
    }
}

export default LoginWithUserAndPasswordApiImpl;